export const urlCategoryId = () => {
    if (location.pathname.includes('nav')) {
        const path = location.pathname.split('/');
        return Number(path[path.length - 1]);
    } 

    return undefined
}